import React from 'react'
import { Image, Text } from '@chakra-ui/react'

import error from 'assets/images/error.svg'
import { InformativeLayer } from 'components/informativeLayer'

interface ErrorPageProps {
  title: string;
  subtitle: string;
  action?: () => any;
  actionText?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ title, subtitle, action, actionText }) => {

  return (
    <div>
      <InformativeLayer
        title={<Text>{title}</Text>}
        subtitle={<Text>{subtitle}</Text>}
        action={action}
        textButton={actionText}
        Image={<Image src={error} alt='Lateral image' />}
      />
    </div>
  )
}

export default ErrorPage
